module.exports = __webpack_public_path__ + "static/media/bg_huawei.395a86ca.png";